import type { RegisterParams } from '@common/workflow/serviceActivityRegistry';
import { CustomControlCode } from '@common/enums';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { headacheAssessmentSections } from './headacheAssesment/headacheAssessment';
import { headacheExaminationSections } from './headacheExamination/headacheExamination';
import { headacheReferralSections } from './headacheReferral/headacheReferral';

const registryElements: RegisterParams[] = [
    {
        customControlCode: CustomControlCode.HeadacheReferral,
        sections: headacheReferralSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HeadacheExamination,
        sections: headacheExaminationSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.HeadacheAssessment,
        sections: headacheAssessmentSections,
        version: 1,
    },
];

ServiceActivityRegistry.instance.registerAll(registryElements);
